import { useSnackbar } from "notistack";

export default function useSnackbars() {
  const { enqueueSnackbar } = useSnackbar();

  const showSnackbar = (message, variant, duration = 5000) => {
    enqueueSnackbar(message, {
      variant: variant,
      autoHideDuration: duration,
    });
  };

  const infoSnackbar = (message) => {
    showSnackbar(message, "info");
  };

  const successSnackbar = (message) => {
    showSnackbar(message, "success");
  };

  const warningSnackbar = (message) => {
    showSnackbar(message, "warning", 30000);
  };

  const errorSnackbar = (message) => {
    showSnackbar(message, "error", 30000);
  };

  const notificationSnackbar = (message) => {
    showSnackbar(message);
  };

  return {
    infoSnackbar,
    successSnackbar,
    warningSnackbar,
    errorSnackbar,
    notificationSnackbar,
  };
}
